var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurveLineDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.635,
    height: 16.295,
    viewBox: "0 0 23.635 16.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44085",
    "data-name": "Path 44085",
    d: "M342.849,166.829a.808.808,0,1,0-1.142-1.142Zm-8.645,7.5-.448.672a.809.809,0,0,0,1.019-.1Zm-4.4-2.936.448-.672a.809.809,0,0,0-1.019.1Zm-10.35,9.542a.807.807,0,0,0,.807.807h7.267a.807.807,0,0,0,0-1.615h-6.459v-6.459a.807.807,0,1,0-1.615,0Zm22.257-15.251-8.074,8.074,1.142,1.142,8.074-8.074Zm-7.055,7.973-4.4-2.936-.9,1.345,4.4,2.936Zm-5.423-2.835-9.542,9.542,1.142,1.142,9.542-9.542Z",
    transform: "translate(-319.45 -165.45)",
    fill: "#4ab778"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveLineDown);
export default __webpack_public_path__ + "static/media/curve-line-down.03b65d3ce3a4bf09c15dff0bb93d32cc.svg";
export { ForwardRef as ReactComponent };